<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';

  import { Spinner } from '@client/components/spinner';

  import { SignaturesService } from '@client/services/signatures';

  import { userStore } from '@client/stores/user';

  const navigate = useNavigate();

  export let groupId = null;
  export let hasChanges = false;

  let items = [];
  let selected = [];
  let loading = false;

  const getUserSignature = async (blockname) => {
    const data = {
      username: $userStore.email,
      scratchblockname: blockname,
      testData: {
        testsender: $userStore.email
      }
    };

    const { rendered } = await SignaturesService.getSignature(data);

    return rendered;
  };

  const getSignatures = async () => {
    loading = true;

    const signatures = await SignaturesService.getAll();

    const matches = signatures
      .filter((item) => {
        return item.sendergroups.filter(({ groupname }) => groupname === groupId).length && item;
      })
      .sort((a, b) => a.priority - b.priority);

    selected = matches.map(({ blockname }) => blockname);

    items = await Promise.all(
      matches.map(async ({ blockname, ...rest }) => ({
        preview: await getUserSignature(blockname),
        label: blockname,
        value: blockname,
        ...rest,
        checked: selected.includes(blockname)
      }))
    );

    loading = false;
  };

  const resizeIframe = function () {
    const zoomFactor = 1;

    this.style.visibility = 'visible';
    this.style.height = ((this.contentWindow.document.body.firstChild?.clientHeight || 0) + 20) / zoomFactor + 'px';
    this.style.width = ((this.contentWindow.document.body.firstChild?.clientWidth || 0) + 20) / zoomFactor + 'px';
  };

  const onPreviewIframeLoad = function (e) {
    resizeIframe.call(this, e, true);
  };

  const onClick = (name) => {
    if (hasChanges) {
      const confirmRedirect = confirm($format('label.CONFIRM.REDIRECT'));

      if (confirmRedirect) {
        navigate(`/signatures/studio/${name}`);
      }
    } else {
      navigate(`/signatures/studio/${name}`);
    }
  };

  getSignatures();
</script>

<div class="routing-assignments">
  {#if loading}
    <div class="preview-container">
      <div class="preview">
        <div class="preview-body">
          <Spinner show />
        </div>
      </div>
    </div>
  {:else if items.length}
    {#each items as item}
      <div class="preview-container" role="button" tabindex="0" on:click={() => onClick(item.label)}>
        <div class="preview">
          <div class="preview-header">
            <div class="preview-title">{item.label}</div>
            <div class="preview-status">
              <div class="preview-badge" class:active={item.status}>
                {item.status ? $format('label.ACTIVE') : $format('label.INACTIVE')}
              </div>
            </div>
          </div>
          <div class="preview-body">
            <iframe
              tabindex="-1"
              style="width: 100%; visibility: hidden;"
              scrolling="no"
              title="Preview"
              on:load={onPreviewIframeLoad}
              srcdoc="<html><body style='transform: scale(.5,.5); transform-origin: left top; -moz-transform: scale(.5,.5); -moz-transform-origin: left top;'>{item.preview ||
                ''}</div></body></html>"
            />
          </div>
          <div class="preview-footer">{$format('label.ROUTE_NUMBER')}{item.priority + 1}</div>
        </div>
      </div>
    {/each}
  {:else}
    {$format('label.NO_ROUTE_ASSIGNMENTS_FOR_THIS_GROUP')}
  {/if}
</div>

<style lang="scss" src="./signature.scss"></style>
